/* src/app/account/modals/tipping-price-create-modal/tipping-price-create-modal.component.scss */
/*# sourceMappingURL=tipping-price-create-modal.component.css.map */
